import {difference} from 'lodash';

export const isNotEmpty = <T>(array: T[]): boolean => Array.isArray(array) && !!array.length;

export const isEmpty = <T>(array: T[]): boolean => !Array.isArray(array) || !array.length;

export const isDifferent = <T>(a: T[], b: T[]): boolean => (isEmpty(a) && isNotEmpty(b)) || (isNotEmpty(a) && isEmpty(b)) || isNotEmpty(difference(a, b)) || isNotEmpty(difference(b, a));

export const isSame = <T>(a: T[], b: T[]): boolean => !isDifferent(a, b);

export const intersection = <T>(a: T[], b: T[]): T[] => a.filter((value: T) => b.indexOf(value) !== -1);

export const arrayIncludes = <T>(needles: T[], heystack: T[]): boolean => needles.every((_) => heystack.includes(_));

export const arrayEquals = <T>(arr1: T[], arr2: T[]): boolean => arrayIncludes<T>(arr1, arr2) && arrayIncludes<T>(arr2, arr1);

export const filterByKey = <T extends {key: string}>(array: T[], keysToFilter: string[]): T[] => array.filter(_ => !keysToFilter.includes(_.key));